import { PopWindowConfig } from '@pop-common/constants/window-constants';
import { isEmpty } from 'lodash';

export const getOrgId = async () => {
  const windowOrgId = ((window as any).hqlai as PopWindowConfig)?.orgId;
  if (!isEmpty(windowOrgId)) {
    return windowOrgId;
  }

  const customClaims = await import('../firebase/auth/get-custom-claims').then((_) => _.getCustomClaims());
  if (customClaims?.getOrgId()) {
    return customClaims.getOrgId();
  }

  console.error('getOrgId: No orgId found');
};
